import React from 'react'
import DropdownMenuToggle from '../../../../components/DropdownMenuToggle'




import useAtmosphere from '../../../../hooks/useAtmosphere'
import {MenuPosition} from '../../../../hooks/useCoords'
import useMenu from '../../../../hooks/useMenu'
import useMutationProps from '../../../../hooks/useMutationProps'
import lazyPreload from '../../../../utils/lazyPreload'
import SlackClientManager from '../../../../utils/SlackClientManager'









const SlackChannelDropdown = lazyPreload(
  () =>
    import(
      /* webpackChunkName: 'SlackChannelDropdown' */
      '../../../../components/SlackChannelDropdown'
    )
)

var ChannelState; (function (ChannelState) {
  const ready = 0; ChannelState[ChannelState["ready"] = ready] = "ready";
  const loading = ready + 1; ChannelState[ChannelState["loading"] = loading] = "loading";
  const error = loading + 1; ChannelState[ChannelState["error"] = error] = "error";
})(ChannelState || (ChannelState = {}));

const SlackChannelPicker = (props) => {
  const {isTokenValid, channels, localChannelId, onClick, teamId} = props
  const activeIdx = localChannelId
    ? channels.findIndex((channel) => channel.id === localChannelId)
    : -1
  const activeChannel = channels[activeIdx]
  const channelState = activeChannel
    ? ChannelState.ready
    : localChannelId && isTokenValid
    ? ChannelState.loading
    : ChannelState.error
  const activeText = activeChannel
    ? activeChannel.name
    : channelState === ChannelState.loading
    ? ''
    : 'Token Expired! Click to renew'
  const {togglePortal, menuPortal, originRef, menuProps} = useMenu(
    MenuPosition.UPPER_RIGHT,
    {
      isDropdown: true
    }
  )
  const atmosphere = useAtmosphere()
  const mutationProps = useMutationProps()
  const handleClick =
    channelState !== ChannelState.error
      ? togglePortal
      : () => {
          SlackClientManager.openOAuth(atmosphere, teamId, mutationProps)
        }
  return (
    React.createElement(React.Fragment, null
      , React.createElement(DropdownMenuToggle, {
        onMouseEnter: SlackChannelDropdown.preload,
        onClick: handleClick,
        ref: originRef,
        defaultText: activeText,}
      )
      , menuPortal(
        React.createElement(SlackChannelDropdown, {
          channels: channels,
          defaultActiveIdx: activeIdx,
          menuProps: menuProps,
          onClick: onClick,}
        )
      )
    )
  )
}

export default SlackChannelPicker
